// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      light: '#e8f5e9', // Light green
      main: '#8bc34a', // Green
      dark: '#388e3c', // Dark green
    },
    secondary: {
      main: '#66bb6a', // Secondary green
    },
    text: {
      primary: '#000', // Black
      secondary: '#666', // Dark gray
    },
  },
});

export default theme;
